import styled from "styled-components";

export const Page = styled.main`
  width: min(960px, 92vw);
  margin: 0 auto;
  padding: 40px 0 64px;
  color: #fff;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 32px;
`;

export const Description = styled.p`
  margin: 8px 0 0;
  color: #d8e3e7;
`;

export const Section = styled.section`
  margin-top: 28px;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
`;

export const Button = styled.button`
  min-height: 44px;
  border: 0;
  border-radius: 6px;
  padding: 0 18px;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  background: #02576d;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SaveButton = styled(Button)`
  background: #4fc66a;
`;

export const DangerButton = styled(Button)`
  background: #8b2635;
`;

export const LoginLink = styled.a`
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  border-radius: 6px;
  padding: 0 18px;
  color: #fff;
  background: #4fc66a;
  font-weight: 700;
  text-decoration: none;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border-bottom: 1px solid rgba(255, 255, 255, 0.18);
    padding: 10px 8px;
    text-align: left;
  }

  th {
    color: #d8e3e7;
    font-size: 14px;
  }
`;

export const Input = styled.input`
  width: 100%;
  min-width: 180px;
  min-height: 40px;
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 0 10px;
  box-sizing: border-box;
  color: #fff;
  background: transparent;
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 160px;
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 12px;
  box-sizing: border-box;
  color: #fff;
  background: transparent;
  font-family: inherit;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 700;
`;

export const Message = styled.p`
  min-height: 24px;
  margin: 12px 0 0;
  color: #d8e3e7;
`;

export const Today = styled.p`
  margin: 0;
  color: #d8e3e7;
`;
